import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="bg-[#111111] py-20 px-4" data-id="element-103">
      <div className="max-w-3xl mx-auto" data-id="element-104">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="mb-16" data-id="element-105">
          <h2 className="text-2xl md:text-3xl font-bold text-white mb-6 leading-snug" data-id="element-106">
            ¿Te has sentido alguna vez como una valla publicitaria gratuita para
            Instagram?
          </h2>
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-107">
            Publicas Reels, editas durante horas, respondes comentarios... y al
            final del mes, tu cuenta bancaria sigue igual. Ves a otros creadores
            viajando y facturando, y te preguntas:{' '}
            <em className="text-indigo-400" data-id="element-108">"¿Qué saben ellos que yo no?"</em>.
            La respuesta no está en su contenido, está en su{' '}
            <strong data-id="element-109">sistema</strong>.
          </p>
        </motion.div>

        <div className="w-24 h-1 bg-indigo-500/30 mx-auto mb-16 rounded-full" data-id="element-110" />

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6" data-id="element-111">
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-112">
            El modelo tradicional de "influencer" en Latinoamérica está muerto.
            Las marcas cada vez pagan menos, los canjes de comida no pagan la
            renta y el alcance orgánico cae un 10% cada trimestre. Si tu
            estrategia es "esperar a que el algoritmo me ayude", estás
            construyendo tu casa en un terreno que no te pertenece.
          </p>
          <p className="text-lg text-gray-300 leading-relaxed" data-id="element-113">
            Estás a un cambio de algoritmo de perderlo todo. Estás atrapado en
            la rueda de hámster del contenido: si dejas de publicar un solo día,
            tus ingresos (o tu esperanza de tenerlos) desaparecen. Ese no es el
            sueño de libertad que te vendieron; eso es un{' '}
            <strong className="text-red-400" data-id="element-114">
              auto-empleo mal pagado y estresante
            </strong>
            .
          </p>
        </motion.div>
      </div>
    </section>;
}